import FormView from './form-view'

/**
 * A form view for a form that has just a single required select
 */
var SingleSelectFormView = FormView.extend({

	test: function() {
		return FormView.prototype.test.apply(this, arguments) ||
			this.$('select').val().length == 0
	}
	
})

export default SingleSelectFormView

SingleSelectFormView.__filename__ = 'components/single-select-form-view.js'
